"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./Home.css");

var _react = _interopRequireDefault(require("react"));

var _Propulator = _interopRequireDefault(require("../../higher-order/Propulator"));

var _MobxView = _interopRequireDefault(require("../../higher-order/MobxView"));

var _constants = require("../../util/constants");

var _HomeStore = _interopRequireWildcard(require("../models/HomeStore"));

var _mobxReact = require("mobx-react");

var _MarketingHero = _interopRequireDefault(require("../components/MarketingHero"));

var _MarketingPageContent = _interopRequireDefault(require("../components/MarketingPageContent"));

var _MarketingVideoHelpers = require("../components/MarketingVideoHelpers");

var _LogoGarden = _interopRequireDefault(require("../components/LogoGarden"));

var _ContentItem = _interopRequireDefault(require("../../shared/components/cms/ContentItem"));

var _Mouseflow = _interopRequireDefault(require("../../shared/components/Mouseflow"));

var _class;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var LEGAL_TEXT_KEYS = ["legalText1", "legalText2"];

var Home = (0, _mobxReact.observer)(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(Home, _React$Component);

  var _super = _createSuper(Home);

  function Home() {
    _classCallCheck(this, Home);

    return _super.apply(this, arguments);
  }

  _createClass(Home, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _Mouseflow.default)();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_MarketingPageContent.default, {
        enableSubfooter: true,
        legalTextKeys: LEGAL_TEXT_KEYS
      }, /*#__PURE__*/_react.default.createElement("img", {
        alt: "background",
        src: require("../assets/redesign2020/background-triangle.svg"),
        className: "marketing-home-background-image"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "marketing-home"
      }, /*#__PURE__*/_react.default.createElement(_MarketingHero.default, {
        desktopImage: require("../assets/redesign2020/home/desktop-hero.png"),
        tabletImage: require("../assets/redesign2020/home/tablet-hero.png"),
        mobileImage: require("../assets/redesign2020/home/mobile-hero.png"),
        containsChevron: true,
        buttonHref: _constants.URLS.MARKETING.PRODUCTS,
        buttonText: "Discover How"
      }, /*#__PURE__*/_react.default.createElement("span", null, "Together, we can"), /*#__PURE__*/_react.default.createElement("span", null, "deliver financial"), /*#__PURE__*/_react.default.createElement("span", null, "wellness benefits"), /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "that work"), "."), /*#__PURE__*/_react.default.createElement("div", {
        className: "marketing-body"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "solutions"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "solutions-body"
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "h2",
        contentKey: "solutionsHeader",
        className: "solutions-header"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "p",
        contentKey: "solutionsBodyText1",
        className: "solutions-body-text"
      }), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "p",
        contentKey: "solutionsBodyText2",
        className: "solutions-body-text"
      }), /*#__PURE__*/_react.default.createElement("a", {
        href: this.props.session.requestInfoUrl,
        className: "solutions-body-link",
        target: "_blank"
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "span",
        contentKey: "solutionsCTA"
      }))), /*#__PURE__*/_react.default.createElement("img", {
        className: "solutions-image",
        alt: "Gradifi FinCore, College SaveUp and Student Loan PayDown",
        src: require("../assets/redesign2020/home/gradifi-products.png")
      })), false && (0, _MarketingVideoHelpers.renderMSAtWorkVideoCard)(this.props.videoModals[_HomeStore.MS_AT_WORK_VIDEO_KEY]), /*#__PURE__*/_react.default.createElement("div", {
        className: "logo-garden-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_LogoGarden.default, null)), /*#__PURE__*/_react.default.createElement("div", {
        className: "impact-card-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "impact-card"
      }, /*#__PURE__*/_react.default.createElement("img", {
        alt: "Gradifi impact on student debt",
        className: "impact-image",
        src: require("../assets/redesign2020/home/impact-graph.png")
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "impact-body"
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "chevron",
        alt: "chevron",
        src: require("../assets/redesign2020/chevron-darker.svg")
      }), /*#__PURE__*/_react.default.createElement("h2", {
        className: "impact-header"
      }, "Build a happier, healthier, ", /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "more productive workforce"), "."), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "p",
        contentKey: "impactBodyText1",
        className: "impact-body-text legal-text-1"
      }), /*#__PURE__*/_react.default.createElement("h3", {
        className: "impact-subheader"
      }, "Give employees access to benefits that can help them ", /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "take control of their financial well-being"), "."), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "p",
        contentKey: "impactBodyText2",
        className: "impact-body-text"
      })), /*#__PURE__*/_react.default.createElement("a", {
        href: _constants.URLS.MARKETING.PAYDOWN,
        className: "button"
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "span",
        contentKey: "impactCTA"
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "talent-card-wrapper"
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "talent-card-background-desktop",
        alt: "background",
        src: require("../assets/redesign2020/home/background-triangle-tablet.png")
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "talent-card"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "talent-card-image-wrapper"
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "talent-card-background-tablet",
        alt: "background",
        src: require("../assets/redesign2020/home/background-triangle-tablet.png")
      }), /*#__PURE__*/_react.default.createElement("img", {
        alt: "Bring in top-tier talent",
        className: "talent-card-image",
        src: require("../assets/redesign2020/home/culture-image.png")
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "talent-card-body"
      }, /*#__PURE__*/_react.default.createElement("img", {
        alt: "chevron",
        className: "chevron",
        src: require("../assets/redesign2020/chevron.svg")
      }), /*#__PURE__*/_react.default.createElement("h2", {
        className: "talent-card-header"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "sentence"
      }, "Bring in top-tier talent."), /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "Build a strong culture"), ".", /*#__PURE__*/_react.default.createElement("span", {
        className: "sentence"
      }, " Improve employee engagement.")), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "p",
        contentKey: "talentCardText",
        className: "talent-card-text"
      }), /*#__PURE__*/_react.default.createElement("a", {
        href: _constants.URLS.MARKETING.CONTACT,
        className: "talent-card-link"
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        sharedKey: "home",
        tag: "span",
        contentKey: "talentCardCTA"
      }))))), (0, _MarketingVideoHelpers.renderMarketingTestimonial)(this.props.videoModals[_HomeStore.ANDERSEN_TAX_VIDEO_KEY]))));
    }
  }]);

  return Home;
}(_react.default.Component)) || _class;

var propulatedView = (0, _Propulator.default)(Home, {
  homeStore: ["enabledOffers", "videoModals"],
  sessionStore: ["featureToggles", "externalUrls", "session"]
});

var _default = (0, _MobxView.default)(propulatedView, {
  HomeStore: _HomeStore.default
});

exports.default = _default;